import useApi from "@/services/useApi";

const defaultState = () => {
    return {
        unreadsCount: 0,
        notifications: [],
        notificationsMeta: {},
        current_page: 1,
        isLoading: false,
        hasMore: true,
        descriptionLoadingItem: null,
        lastNotification: null
    }
}

const notificationsModule = {
    namespaced: true,
    state: defaultState(),
    getters: {
        getUnreadsCount: (state) => {
            return state.unreadsCount
        },
        getNotifications: (state) => {
            return state.notifications
        },
        getIsLoading: (state) => {
            return state.isLoading
        },
        getDescriptionLoadingItem: (state) => {
            return state.descriptionLoadingItem
        },
        getHasMore: (state) => {
            return state.hasMore
        },
        getLastErrorNotification: (state) => {
            return (state.lastNotification && state.lastNotification.level) === 'error'
                ? state.lastNotification
                : null
        }
    },
    mutations: {
        SET_UNREADS_COUNT(state, count) {
            state.unreadsCount = count
        },
        SET_NOTIFICATIONS(state, notifications) {
            state.notifications = notifications
        },
        APPEND_NOTIFICATIONS(state, notifications) {
            state.notifications = [...state.notifications, ...notifications]
        },
        SET_CURRENT_PAGE(state, page) {
            state.current_page = page
        },
        SET_LOADING(state, isLoading) {
            state.isLoading = isLoading
        },
        SET_DESCRIPTION_LOADING_ITEM(state, id) {
            state.descriptionLoadingItem = id
        },
        SET_HAS_MORE(state, hasMore) {
            state.hasMore = hasMore
        },
        RESET_NOTIFICATIONS(state) {
            state.notifications = []
            state.current_page = 1
            state.hasMore = true
        },
        SET_NOTIFICATION_TEXT(state, {notification_id ,text}) {
            state.notifications.forEach((notification) => {
                if (notification.id === notification_id) {
                    notification.text = text
                }
            })
        },
        SET_LAST_NOTIFICATION(state, n) {
            state.lastNotification = n;
        }
    },
    actions: {
        async getNotifications({ commit, state }) {
            if (!state.hasMore || state.isLoading) return;

            commit('SET_LOADING', true);
            const {api, headers} = useApi();

            try {
                if (state.notificationsMeta?.total === state.notifications.length) {
                    commit('SET_HAS_MORE', false);
                    return;
                }

                const response = await api.get('/api/notifications', {
                    headers,
                    params: {
                        page: state.current_page,
                    }
                });
                state.notificationsMeta = response.data.meta;

                if (state.current_page === 1) {
                    commit('SET_NOTIFICATIONS', response.data.data);

                    if (!state.lastNotification) {
                        commit('SET_LAST_NOTIFICATION', response.data.data[0])
                    }
                } else {
                    commit('APPEND_NOTIFICATIONS', response.data.data);
                }

                commit('SET_CURRENT_PAGE', state.current_page + 1);
            } catch (error) {
                commit("setToastContent", {
                    status: "error",
                    description: error.response?.data?.description || "error"
                }, { root: true })
            } finally {
                commit('SET_LOADING', false);
            }
        },
        async getTheCountOfUnreads({ commit }) {
            const {api, headers } = useApi();
            try {
                const response = await api.get('/api/notifications/count', {headers});
                commit('SET_UNREADS_COUNT', response.data.data.count);
            } catch (error) {
                commit("setToastContent", {
                    status: "error",
                    description: error.response?.data?.description || "error"
                }, { root: true })
            }
        },
        async getNotificationDescriptionById({commit},notification_id) {
            const {api, headers} = useApi()
            commit('SET_DESCRIPTION_LOADING_ITEM', notification_id)
            try {
                const response = await api.get(`/api/notifications/${notification_id}`, {headers})
                const {text} = response.data.data;
                commit('SET_NOTIFICATION_TEXT', {notification_id, text})
            } catch (error) {
                commit("setToastContent", {
                    status: "error",
                    description: error.response?.data?.description || "error"
                }, { root: true })
                commit('SET_NOTIFICATION_TEXT', {notification_id, text: {
                    ua: '<p>Не вдалось завантажити</p>',
                    ru: '<p>Не удалось загрузить</p>',
                    en: '<p>Could not load</p>'
                }})
            } finally {
                commit('SET_DESCRIPTION_LOADING_ITEM', null)
            }
        },
        async readAllNotification({commit}) {
            const {api, headers} = useApi();

            try {
                await api.post('/api/notifications/read-all', {headers})
                commit('SET_UNREADS_COUNT', 0)
            } catch (error) {
                commit("setToastContent", {
                    status: "error",
                    description: error.response?.data?.description || "error"
                }, { root: true })
            }
        },
    }
}

export default notificationsModule;
